<template>
  <div class="row justify-content-md-center">
    <div class="col-12 form-group">
      <label class="form-control-label">Descrição do Ano Safra<span class="text-danger"> *</span></label><br>
      <input
        type="text"
        class="form-control"
        placeholder="Nome do Ano Safra"
        :value="anosafra.descricao"
        @input="handleInputDescricao($event)"
        aria-label="Nome do Ano Safra"
      />
      <div v-if="errors.descricao" class="invalid-feedback" style="display: block;">
        {{ errors.descricao.join(', ') }}
      </div>
    </div>
    <div class="col-12 form-group">
      <label class="form-control-label">Duração do Ano Safra<span class="text-danger"> *</span></label><br>
      <el-date-picker
        v-model="anosafraDateRange"
        type="daterange"
        range-separator="-"
        :editable="false"
        start-placeholder="Data início"
        end-placeholder="Data fim"
        unlink-panels
        @change="() => clearDate('start_date')"
        prefix-icon="fa fa-calendar"
        format="d 'de' MMMM 'de' yyyy">
      </el-date-picker>
      <div v-if="errors.start_date || errors.end_date" class="invalid-feedback" style="display: block;">
        {{ errors.start_date.join(', ') || errors.end_date.join(', ') }}
      </div>
    </div>
    <div class="col-12 form-group">
      <label class="form-control-label">Período de Alterações<span class="text-danger"> *</span></label><br>
      <el-date-picker
        v-model="updateDateRange"
        type="daterange"
        range-separator="-"
        :editable="false"
        start-placeholder="Data início"
        end-placeholder="Data fim"
        unlink-panels
        @change="() => clearDate('update_start_date')"
        prefix-icon="fa fa-calendar"
        format="d 'de' MMMM 'de' yyyy">
      </el-date-picker>
      <div v-if="errors.update_start_date || errors.update_end_date" class="invalid-feedback" style="display: block;">
        {{ errors.update_start_date.join(', ') || errors.update_end_date.join(', ') }}
      </div>
    </div>
    <div class="col-12 form-group">
      <label class="form-control-label">Perfil com permissão de alteração<span class="text-danger"> *</span></label><br>
      <multiselect
        v-model="anosafraUpdatableBy"
        :options="updatableOptions"
        label="label"
        track-by="value"
        :allow-empty="false"
        :preserveSearch="true"
        :showNoResults="false"
        select-label=""
        deselect-label=""
        placeholder="Selecionar Perfil"
        :selected-label="'Selecionado'"
      />
      <div v-if="errors.updatable_by && !anosafraUpdatableBy" class="invalid-feedback" style="display: block;">
        {{ errors.updatable_by.join(', ') }}
      </div>
    </div>
    <div class="col-12 form-group" v-if="canChangeCopyStatus">
      <label class="form-control-label">Copiar volume realizado do Ano Safra anterior neste Ano Safra?</label><br>
      <div class="row justify-content-md-center">
        <div class="col">
          <base-checkbox
            :checked="anosafra.copyPreviousVolume"
            @input="$set(anosafra, 'copyPreviousVolume', !anosafra.copyPreviousVolume)"
          >
            sim
          </base-checkbox>
        </div>
        <div class="col">
          <base-checkbox
            :checked="!anosafra.copyPreviousVolume"
            @input="$set(anosafra, 'copyPreviousVolume', !anosafra.copyPreviousVolume)"
          >
            não
          </base-checkbox>
        </div>
      </div>
    </div>
    <div class="col-12 form-group" v-if="canChangeCopyStatus">
      <label class="form-control-label">Deseja incluir porcentagens sobre os volumes das metas após salvar o Ano Safra?</label><br>
      <div class="row justify-content-md-center">
        <div class="col">
          <base-checkbox
            :disabled="!anosafra.copyPreviousVolume"
            :checked="anosafra.addPercentage"
            @input="$set(anosafra, 'addPercentage', !anosafra.addPercentage)"
          >
            sim
          </base-checkbox>
        </div>
        <div class="col">
          <base-checkbox
            :disabled="!anosafra.copyPreviousVolume"
            :checked="!anosafra.addPercentage"
            @input="$set(anosafra, 'addPercentage', !anosafra.addPercentage)"
          >
            não
          </base-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCheckbox from "../Inputs/BaseCheckbox.vue";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import { DatePicker } from "element-ui";

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['input'],
  components: {
    BaseCheckbox,
    Multiselect,
    [DatePicker.name]: DatePicker,
  },
  data: () => ({
    updatableOptions: [
      {label: 'Administradores', value: 'admin'},
      {label: 'Gerentes Comerciais',        value: 'manager'},
      {label: 'Vendedores',      value: 'salesman'},
    ],
  }),
  methods: {
    clearDate(field) {
      if (field === 'start_date' || field === 'end_date') {
        this.errors.start_date = [];
        this.errors.end_date = [];
      } else if (field === 'update_start_date' || field === 'update_end_date') {
        this.errors.update_start_date = [];
        this.errors.update_end_date = [];
      }
    },
    handleInputDescricao(event) {
      this.$set(this.anosafra, 'descricao', event.target.value);
      if (this.errors.descricao) {
        this.clearError('descricao'); 
      }
    },
    clearError(field) {
      if (this.errors[field]) {
        this.errors[field] = []; 
      }
    },
    updateAnosafraCopyStatus() {
      if (this.canChangeCopyStatus) return

      if (this.anosafra.copyPreviousVolume) {
        this.$set(anosafra, 'copy_status', "to_do")
      } else {
        this.$set(anosafra, 'copy_status', "wont_copy")
      }
    }
  },
  computed: {
    canChangeCopyStatus() {
      if (!this.anosafra.copy_status) return true
      if (!['doing', 'done', 'failed'].includes(this.anosafra.copy_status)) return true

      return false
    },
    anosafra: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)

        this.updateAnosafraCopyStatus()
      }
    },
    updateDateRange: {
      get: function() {
        return [this.anosafra.update_start_date, this.anosafra.update_end_date];
      },
      set: function(range) {
        this.anosafra = Object.assign({}, this.anosafra, {
          update_start_date: range && range[0] || '',
          update_end_date: range && range[1] || ''
        });
      },
    },
    anosafraDateRange: {
      get: function() {
        return [this.anosafra.start_date, this.anosafra.end_date];
      },
      set: function(range) {
        this.anosafra = Object.assign({}, this.anosafra, {
          start_date: range && range[0] || '',
          end_date: range && range[1] || ''
        });
      },
    },
    anosafraUpdatableBy: {
      get() {
        return this.updatableOptions.find(option => option.value == this.anosafra.updatable_by)
      },
      set(val) {
        this.anosafra = Object.assign({}, this.anosafra, {
          updatable_by: val.value,
        })
      },
    },
  }
}
</script>
